import voiceText from "@/config/voiceText"

export const mx_terminal_audio_config = {
  clickVoice: 'clickVoice',  // 点击提示音
  successVoice: 'successVoice', // 订餐成功提示音
  selectFoodVoice: 'selectFoodVoice', // 选择菜品提示音
  thanksVoice: 'thanksVoice' // 谢谢提示音
};


export const terminalAudioMixins = {
  data() {
    return {
      mx_terminal_audio_config: mx_terminal_audio_config,
      mx_dom_config: {
        clickVoice: ''
      },
      mx_voice_text: voiceText
    }
  }
}




// WEBPACK FOOTER //
// ./src/mixins/terminalAudioMixins.js